import { media } from 'helpers/mediaQueryStyle'
import styled from 'styled-components'

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  padding: 0;
  border-radius: 0.5rem;
  width: 100%;
  min-height: 100vh;

  ${media.mobileWithTablet`
    padding: 0;
  `}
`

export const WhiteCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  ${media.mobileWithTablet`
    padding: 1.5rem;
    border-radius: 6px;
  `}
`

export const SectionSubtitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #433f3e;
  margin: 0 0 1rem 0;
`

export const HeadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  > h2 {
    margin-bottom: 0;
  }

  ${media.mobileWithTablet`
    margin-bottom: 1rem;
  `}
`

export const Heading = styled.h2`
  color: #433f3e;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 1.5rem;

  .calendar-icon {
    width: 1.5rem;
    height: 1.5rem;
    color: #433f3e;
    flex-shrink: 0;
  }

  span {
    line-height: 140%;
  }

  ${media.mobileWithTablet`
    font-size: 16px;
    margin-bottom: 1rem;
  `}
`
export const FilterBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  ${media.mobile`
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 1rem;
  `}
`

export const SearchBox = styled.div`
  flex: 1;
  min-width: 200px;

  * {
    font-family: 'Poppins', sans-serif;
  }
  .input_wrapper {
    height: 36px;
    border-radius: 4px;
    border: 1px solid #cccccc;
    background: #edece7;
  }

  .ant-picker {
    background: none;
    border: none;
  }
  .ant-picker-input {
    display: none;
  }

  ${media.mobile`
    width: 100%;
    .input_wrapper {
      height: 40px;
    }
  `}
`

export const Filters = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;

  * {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    color: #424242;
  }
  .button_dropdown {
    width: fit-content;
    border: none;
    background: transparent;
    img {
      filter: invert(21%) sepia(15%) saturate(0%) hue-rotate(268deg) brightness(90%) contrast(86%);
    }

    svg {
      color: #3d3d3d;
    }
  }

  ${media.mobile`
    width: 100%;
    justify-content: flex-start;
    gap: 0.5rem;
  `}
`

export const ConsultationCount = styled.span`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #433f3e;
  white-space: nowrap;
`

export const Separator = styled.div`
  width: 0.5px;
  height: 27px;
  background: #3d3d3d;
  margin: 0 12px;
  /*   transform: rotate(90deg); */
`

export const ListAppointments = styled.div`
  margin-top: 1.5rem;
  width: 100%;
`

export const GroupedConsultationsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 2rem;

  h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #433f3e;
    margin: 0;
    margin-bottom: 1rem;
    margin-top: 1.5rem;

    &:first-child {
      margin-top: 0;
    }
  }
`

export const LoadingContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PaginateBox = styled.div`
  padding: 38px 0;
  width: 100%;

  li.selected {
    background: #646464;
  }
`
